"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const setPageValue = ({ entryVars: { key, value }, processor, }) => {
    if (typeof key !== 'string' || !key) {
        processor.root.alert('Invalid key to setPageValue', `${key}`);
        return;
    }
    if (processor.ovewritedPageParams) {
        // eslint-disable-next-line no-param-reassign
        processor.ovewritedPageParams[key] = value;
        return;
    }
    processor.root.routing.dangerouslySetCurrentPageParam(key, value);
};
exports.default = setPageValue;
